class MHeader extends HTMLElement {
  constructor() {
    super();
    this.selectors = {
      headers: ["header"],
      logos: [".m-logo"],
      topbar: ".m-topbar",
      headerWrapper: ".m-header__wrapper",
      topbarClose: ".m-topbar__close",
    };
    this.classes = {
      scrollUp: "scroll-up",
      scrollDown: "scroll-down",
      stuck: "stuck",
      always: "header-sticky-always",
      headerScrollUp: "header-scroll-up",
      headerScrollDown: "header-scroll-down",
    };
  }

  connectedCallback() {
    // Listeners below are window/document-level; binding them again on re-connect stacks them.
    if (this._initialized) return;
    this._initialized = true;
    this.domNodes = queryDomNodes(this.selectors, this);
    this.innerWidth = window.innerWidth;
    this.headerOffsetTop = (this.domNodes && this.domNodes.headerWrapper) ? this.domNodes.headerWrapper.offsetTop : 0;
    this.headerHeight = (this.domNodes && this.domNodes.headerWrapper) ? this.domNodes.headerWrapper.offsetHeight : 0;
    this.stickyHeader = this.dataset.sticky;
    this.init();
  }

  init() {
    this.transparentHeader =
      this.domNodes && this.domNodes.headers[0] && this.domNodes.headers[0].dataset.transparent === "true";
    this.initAddon();
    this.handleSticky();
    document.addEventListener("matchMobile", () => this.handleSticky());
    document.addEventListener("unmatchMobile", () => this.handleSticky());
    const initSiteNav = () => {
      if (typeof SiteNav === "function" && !this.siteNav) this.siteNav = new SiteNav(this);
    };
    initSiteNav();
    if (!this.siteNav) window.addEventListener("load", initSiteNav, { once: true });
    window.__sfHeader = this;
    window.addEventListener("resize", () => {
      this.innerWidth = window.innerWidth;
    });
  }

  initAddon() {
    // mega-menu.js is a separate deferred file; when it fails to download (flaky mobile network,
    // blocker, in-app browser) Clarity logged "Megamenu is not defined" and header init stopped here.
    // Skip it, and retry once on load, instead of throwing before sticky/site-nav setup.
    const initMegamenu = () => {
      if (typeof Megamenu === "function" && !this.megamenu) this.megamenu = new Megamenu(this);
    };
    initMegamenu();
    if (!this.megamenu) window.addEventListener("load", initMegamenu, { once: true });
    if (Shopify.designMode) {
      MinimogTheme = MinimogTheme || {};
      MinimogTheme && MinimogTheme.Wishlist && MinimogTheme.Wishlist.updateWishlistCount();
    }
  }
  handleSticky() {
    let extraSpace = 20;
    const sectionGroups = document.querySelectorAll(".shopify-section-group-header-group");
    sectionGroups.forEach((section) => {
      if (!section.classList.contains("m-section-header") && !section.classList.contains("m-section-scaling-logo")) {
        extraSpace += section.offsetHeight;
      }
    });
    const topBar = document.querySelector(".m-topbar");
    if (topBar) extraSpace += topBar.offsetHeight;
    this.extraSpace = extraSpace;

    // Breakpoint changes call this again; only re-measure, never add a second scroll listener.
    if (this.onScroll) return;
    this.lastScroll = 0;
    let ticking = false;
    this.onScroll = () => {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(() => {
        ticking = false;
        this.updateStickyState();
      });
    };
    window.addEventListener("scroll", this.onScroll, { passive: true });
  }

  updateStickyState() {
    const extraSpace = this.extraSpace;
    const lastScroll = this.lastScroll;
    const currentScroll = window.scrollY;
    if (currentScroll <= extraSpace) {
      this.classList.remove(this.classes.scrollUp, this.classes.stuck, this.classes.always);
      document.body.classList.remove(this.classes.headerScrollUp, this.classes.headerScrollDown);
      return;
    }

    if (this.stickyHeader === "on_scroll_up") {
      this.classList.add(this.classes.stuck);
    } else if (this.stickyHeader === "always") {
      this.classList.add(this.classes.always);
    }

    if (
      currentScroll > this.headerHeight + extraSpace &&
      currentScroll > lastScroll &&
      !this.classList.contains(this.classes.scrollDown)
    ) {
      this.classList.remove(this.classes.scrollUp);
      document.body.classList.remove(this.classes.headerScrollUp);
      this.classList.add(this.classes.scrollDown);
      document.body.classList.add(this.classes.headerScrollDown);
    } else if (currentScroll < lastScroll && this.classList.contains(this.classes.scrollDown)) {
      this.classList.remove(this.classes.scrollDown);
      document.body.classList.remove(this.classes.headerScrollDown);
      this.classList.add(this.classes.scrollUp);
      document.body.classList.add(this.classes.headerScrollUp);
    }
    this.lastScroll = currentScroll;
  }
}
if (!customElements.get("m-header")) {
  customElements.define("m-header", MHeader);
}
